const namespace = '[TRIP_EDIT]';
export const TRIP_EDIT_FETCH_TRIP = `${namespace} FETCH TRIP`;
export const TRIP_EDIT_SET_TRIP_ID = `${namespace} SET_TRIP_ID`;
export const TRIP_EDIT_SET_TICKETS = `${namespace} SET_TICKETS`;
export const TRIP_EDIT_SAVE_TRIP = `${namespace} SAVE TRIP`;
export const TRIP_EDIT_REMOVE_TICKET = `${namespace} REMOVE_TICKET`;
export const TRIP_EDIT_SET_SEARCH_RESULT_TICKETS = `${namespace} SET_SEARCH_RESULT_TICKETS`;
